/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { InjectionToken } from "@angular/core";

export interface ISelectSystemFacade {
    selectManageMode(): any;
    selectSystemInfo(): any;
    updateSystemInfo(data: any): any;
    getSystemState(): any;
}

export const SELECT_SYSTEM_FACADE_TOKEN = new InjectionToken<ISelectSystemFacade>('SELECT_SYSTEM_FACADE_TOKEN');